import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58692084"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content_wrapper refund_order_wrapper" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "back_button_img",
  src: "/assets/img/arrow-left.svg"
}, null, -1))
const _hoisted_4 = { class: "refund_order_page_wrapper" }
const _hoisted_5 = { class: "refund_order_data" }
const _hoisted_6 = { class: "w-100 mb-1" }
const _hoisted_7 = { class: "refund_order_title" }
const _hoisted_8 = { class: "mt-3 refund_order_data_block" }
const _hoisted_9 = { class: "block_label" }
const _hoisted_10 = { class: "block_info" }
const _hoisted_11 = { class: "mt-3 refund_order_data_block" }
const _hoisted_12 = { class: "block_label" }
const _hoisted_13 = { class: "block_info" }
const _hoisted_14 = { class: "mt-3 refund_order_data_block" }
const _hoisted_15 = { class: "block_label" }
const _hoisted_16 = { class: "block_info" }
const _hoisted_17 = { class: "button_wrapper" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "refund_order_data mt-6" }
const _hoisted_21 = { class: "receipt_link_wrapper" }
const _hoisted_22 = { class: "my-0" }
const _hoisted_23 = ["href"]

export function render(_ctx, _cache) {
  const _component_v_last_viewed_clients_tabs = _resolveComponent("v-last-viewed-clients-tabs")
  const _component_v_alert = _resolveComponent("v-alert")
  const _component_v_client_tabs_menu = _resolveComponent("v-client-tabs-menu")
  const _component_v_datatable = _resolveComponent("v-datatable")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_last_viewed_clients_tabs, {
      currentClientId: _ctx.refundOrder?.clientId
    }, null, 8, ["currentClientId"]),
    _createVNode(_component_v_alert, {
      modelValue: _ctx.showProcessAlert,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.showProcessAlert) = $event)),
      title: 'refund_order.alert_process',
      text: 'refund_order.process_alert_text',
      successButtonText: _ctx.$t('refund_order.confirm'),
      cancelButtonText: _ctx.$t('refund_order.cancel'),
      onSuccess: _ctx.processRefundOrder,
      onCancel: _cache[1] || (_cache[1] = $event => (_ctx.showProcessAlert = false))
    }, null, 8, ["modelValue", "title", "text", "successButtonText", "cancelButtonText", "onSuccess"]),
    _createVNode(_component_v_alert, {
      modelValue: _ctx.showCancelAlert,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.showCancelAlert) = $event)),
      title: 'refund_order.alert_cancel',
      text: 'refund_order.cancel_alert_text',
      successButtonText: _ctx.$t('refund_order.confirm'),
      cancelButtonText: _ctx.$t('refund_order.cancel'),
      onSuccess: _ctx.cancelRefundOrder,
      onCancel: _cache[3] || (_cache[3] = $event => (_ctx.showCancelAlert = false))
    }, null, 8, ["modelValue", "title", "text", "successButtonText", "cancelButtonText", "onSuccess"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_client_tabs_menu, {
        clientId: _ctx.refundOrder?.clientId,
        activeTab: "payment-info"
      }, null, 8, ["clientId"]),
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = $event => (_ctx.$router.push(`/client/${_ctx.refundOrder?.clientId}/payment-info`))),
        class: "button button_back",
        disabled: !_ctx.refundOrder?.clientId
      }, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('refund_order.payments')), 1)
      ], 8, _hoisted_2),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("p", { class: "refund_order" }, "RORD #" + _toDisplayString(_ctx.refundOrder?.refundOrderId?.toString().padStart(8, '0')), 513), [
                [_vShow, _ctx.isLoaded]
              ]),
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass('refund_order_status status_text_' + _ctx.refundOrderStatus)
              }, _toDisplayString(_ctx.$t('refund_order_status.' + _ctx.refundOrderStatus)), 3), [
                [_vShow, _ctx.isLoaded]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('refund_order.amount')), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.getFormatedAmount(_ctx.refundOrder?.total)) + " " + _toDisplayString(_ctx.refundOrder?.currencySign), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('refund_order.date')), 1),
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.getFormatedDate(_ctx.refundOrder?.dueDate, "DD.MM.yyyy") || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('refund_order.description')), 1),
            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.refundOrder?.comment), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          (_ctx.refundOrder?.canBeProcessed && _ctx.hasProcessPermission)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "refund_order_process_button",
                onClick: _cache[5] || (_cache[5] = $event => (_ctx.showProcessAlert = true)),
                disabled: _ctx.isButtonDisabled
              }, _toDisplayString(_ctx.$t('refund_order.process_refund_order')), 9, _hoisted_18))
            : _createCommentVNode("", true),
          (_ctx.refundOrder?.processingStatus == 0 && _ctx.hasCancelPermission)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "refund_order_cancel_button",
                onClick: _cache[6] || (_cache[6] = $event => (_ctx.showCancelAlert = true)),
                disabled: _ctx.isButtonDisabled
              }, _toDisplayString(_ctx.$t('refund_order.cancel_refund_order')), 9, _hoisted_19))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("h3", _hoisted_22, _toDisplayString(_ctx.$t('refund_order.refund_order_details')), 1),
            (_ctx.refundOrder?.receiptUrl)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "receipt_link",
                  href: _ctx.refundOrder?.receiptUrl,
                  target: "_blank"
                }, _toDisplayString(_ctx.$t('refund_order.open_receipt')), 9, _hoisted_23))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_v_datatable, {
            class: "mt-3",
            columTemplates: _ctx.refundOrderItemsColumTemplates,
            data: _ctx.refundOrderItemsTableData,
            isLoading: !_ctx.isLoaded
          }, null, 8, ["columTemplates", "data", "isLoading"])
        ])
      ])
    ])
  ], 64))
}